//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, reactive, ref } from '@nuxtjs/composition-api';
import MoominFooter from '~/themes/fiskarsMoominDefault/components/components/organisms/MoominFooter/MoominFooter.vue';
export default defineComponent({
  name: "AppFooter",
  components: {MoominFooter},
  props: {
    footerData: {
      type: Object,
      default: () => ({
        footerLinksGroup: [],
        paymentMethodsGroup: {
          title: '',
          items: []
        },
        partnersGroup: {
          title: '',
          items: []
        },
        socialGroup: {
          title: '',
          items: []
        },
      })
    },
  },
  setup(props) {
    const {footerLinksGroup, paymentMethodsGroup, partnersGroup, socialGroup, copyRight} = props.footerData;
    const footerLinks = reactive([...footerLinksGroup]);
    const copyright = ref(copyRight);
    const paymentMethods = reactive({
      "title": paymentMethodsGroup.title,
      "items": []
    });
    const deliveryPartners = reactive({
      "title": partnersGroup.title,
      "items": []
    })
    const socialMedia = reactive({
      "title": socialGroup.title,
      "items": []
    })

    const parseData = (response, newResponse, join) => {
      response.forEach(item => {
        newResponse.push({
          "url": item[join] ? item[join]["link"] : '',
          "image": item[join] ? item[join]["image"] : {},
          "title": item[join] ? item[join]["title"] : ''
        })
      })
    }

    parseData(socialGroup.items, socialMedia.items, "socialLink");
    parseData(partnersGroup.items, deliveryPartners.items, "partner");
    parseData(paymentMethodsGroup.items, paymentMethods.items, "paymentMethod");


    return {
      footerLinks,
      paymentMethods,
      deliveryPartners,
      socialMedia,
      copyright,
      parseData
    }
  }
})
